import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { Hero } from '@/components/sections/Hero';
import { WhyUs } from '@/components/sections/WhyUs';
import { Services } from '@/components/sections/Services';
import { Contact } from '@/components/sections/Contact';
import { CTASection } from '@/components/sections/CTASection';
import { FloatingWhatsApp } from '@/components/FloatingWhatsApp';
import { Toaster } from '@/components/ui/sonner';

export const HomePage = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>MARKETYZE | Google Ads, Tag Manager & Analytics Experts</title>
        <meta name="description" content="Drive measurable growth with expert Google Ads, Google Tag Manager, and Google Analytics consulting from former Google specialists. Book a free audit today." />
        <link rel="canonical" href="https://marketyze.eu/" />
        <meta property="og:title" content="MARKETYZE | Google Ads, Tag Manager & Analytics Experts" />
        <meta property="og:url" content="https://marketyze.eu/" />
        <meta name="twitter:title" content="MARKETYZE | Google Ads, Tag Manager & Analytics Experts" />
      </Helmet>
      <Navbar />
      <main>
        <Hero />
        <WhyUs />
        <Services />
        <Contact />
        <CTASection />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <Toaster position="top-right" />
    </div>
  );
};

export default HomePage;
